export const formatCurrency = cash => {
    let money = Intl.NumberFormat('es-AR');
    return money.format(cash) || cash
}